export enum NotificationHubRequestType {
  CountSummary = 1,
}
